import './userList.css';
import { DataGrid } from '@mui/x-data-grid';
import { DeleteOutline, InfoOutlined } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Paper,
  Stack,
} from '@mui/material';

function UserList() {
  const server_url = process.env.REACT_APP_API_URI;
  const navigate = useNavigate();
  const [data, setUserData] = useState([]);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const getAllUser = async () => {
    try {
      const url = `${server_url}/user/get-all-user`;
      const response = await axios.get(url);
      setUserData(response.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  useEffect(() => {
    getAllUser();
  }, []);

  const handleUserDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        const url = `${server_url}/user/delete-user`;
        const response = await axios.post(url, { id });
        alert(response.data.msg);
        if (response.data.status) {
          await getAllUser();
        }
      } catch (err) {
        console.error('Error deleting user:', err);
      }
    }
  };

  const columns = [
    { field: '_id', headerName: 'ID', flex: 1, minWidth: 150 },
    { field: 'email', headerName: 'Email', flex: 1.2, minWidth: 180 },
    { field: 'subject', headerName: 'Subject', flex: 1, minWidth: 150 },
    { field: 'school', headerName: 'School', flex: 1, minWidth: 150 },
    {
      field: 'role',
      headerName: 'User Role',
      flex: 0.8,
      minWidth: 130,
      renderCell: ({ row }) => {
        const roles = {
          1: 'Admin',
          2: 'Student',
          3: 'Faculty',
          4: 'Guest User',
        };
        return (
          <Typography variant="body2">
            {roles[row.role] || 'Unknown'}
          </Typography>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 0.6,
      minWidth: 120,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={1}>
          <IconButton
            component={Link}
            to={`/admin/user/${row._id}`}
            size="small"
            color="primary"
          >
            <InfoOutlined />
          </IconButton>
          <IconButton
            onClick={() => handleUserDelete(row._id)}
            size="small"
            color="error"
          >
            <DeleteOutline />
          </IconButton>
        </Stack>
      ),
    },
  ];

  return (
    <Box p={isMobile ? 1 : 3} className="userList ">
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        gutterBottom
        fontWeight="bold"
      >
        User Management
      </Typography>
      <Paper
        elevation={4}
        sx={{
          height: '75vh',
          width: '100%',
          borderRadius: 3,
          overflow: 'hidden',
          p: isMobile ? 1 : 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          columns={columns}
          pageSize={isMobile ? 8 : 1}
          // rowsPerPageOptions={[8, 15, 20]}
          // disableSelectionOnClick
          sx={{
            border: 'none',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f2f5',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-cell': {
              fontSize: isMobile ? '0.85rem' : '1rem',
              py: isMobile ? 1 : 1.5,
            },
            '& .MuiDataGrid-footerContainer': {
              backgroundColor: '#f9f9f9',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </Paper>
    </Box>
  );
}

export default UserList;
